import request from '@/utils/request';
export function querySupplierOffer(data) {
  // 查询服务商报价列表
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/querySupplierOffer',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function getCatRepair(data) {
  // 获取推送报修信息
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/getCatRepair',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function choiceSupplierOffer(data) {
  // 选择服务商报价提交（单台仪器）
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/choiceSupplierOffer',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function choiceSupplierOffer_new(data) {
  // 选择服务商报价提交（多种仪器）
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOffer/choiceSupplierOffer',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function saveSupplierOffer(data) {
  // 工单报修预算大于20万（包含）-填写报价
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/saveSupplierOfferToZS',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function queryWorkbenchStatistics(data) {
  // 查询工作台工单统计数据
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/queryWorkbenchStatistics',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function queryRepairsInfoForList(data) {
  // 报修单/审批单/验收单/结算单列表，点击台数显示的维修仪器信息
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/queryRepairsInfoForList',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function queryRepairsInstrumentInfoPageList(data) {
  //新-- 报修单/审批单//结算单列表，点击台数显示的维修仪器信息
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/queryRepairsInstrumentInfoPageList',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function queryManualInstrumentInfoPageList(data) {
  //手工新-- 报修单/审批单//结算单列表，点击台数显示的维修仪器信息
  return request({
    url: '/ysa-afterSale-service/after_sale/asAssetDeptFundStat/queryManualInstrumentInfoPageList',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function queryAcceptanceInstrumentPageList(data) {
  //新-- 验收单点击台数显示的维修仪器信息
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/queryAcceptanceInstrumentPageList',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function queryRepairsInfoPageList(data) {
  // 查询报修单列表
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/queryRepairsInfoPageList',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function withdrawRepair(data) {
  // 报修列表-撤单
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/withdrawRepair',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function queryApprovalPageList(data) {
  // 查询审批单列表
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/queryApprovalPageList',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function queryAcceptancePageList(data) {
  // 查询验收单列表
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/queryAcceptancePageList',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function queryStatementPageList(data) {
  // 查询结算单列表
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/queryStatementPageList',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function exportSettleSummary(data) {
  // 生成结算汇总(导出)
  return request({
    url: '/ysa-afterSale-service/after_sale/asStatementTotal/generateStatementTotal',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function republishMainRepairInfo(data) {
  // 报修单列表-重新发布
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/republishMainRepairInfo',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function getRepairProofDetail(data) {
  // 选择报价-查询维修论证详情
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/getRepairProofDetail',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function queryUserInfoPageList(data) {
  // 选择报价-查询专家列表
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/queryUserInfoPageList',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function queryUserInfoList(data) {
  // 选择报价-使用单位、设备处查询
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/queryUserInfoList',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function queryUserInfo(data) {
  // 选择报价-使用单位、设备处查询
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/queryUserInfo',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function saveRepairProof(data) {
  // 选择报价-保存维修论证
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/saveRepairProof',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function signRepairOrder(data) {
  // 论证签批
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/signRepairOrder',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function queryAsStatementFileList(data) {
  // 结算单查询其它附件列表
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/queryAsStatementFileList',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function querySupplierOfferFile(data) {
  // 结算单查询报价单附件
  return request({
    url: "/ysa-afterSale-service/after_sale/asRepairOrdersMain/querySupplierOfferFile/".concat(data.repairNo),
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function queryAcceptanceAttachmentFile(data) {
  // 结算单查询服务报告附件
  return request({
    url: "/ysa-afterSale-service/after_sale/asRepairOrdersMain/queryAcceptanceAttachmentFile/".concat(data.repairNo),
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function saveStatementFile(data) {
  // 结算单列表-报账材料添加附件
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/saveStatementFile',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function deleteStatementFile(data) {
  // 结算单列表-报账材料删除附件
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/deleteStatementFile',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function returnStatementOrder(id) {
  // 结算单列表-报账材料删除附件
  return request({
    url: "/ysa-afterSale-service/after_sale/asRepairOrdersMain/returnStatementOrder/".concat(id),
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(id)
  });
}
export function queryRepairInfoByStatementNo(data) {
  // 结算单列表-报账材料-登记表详情
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/queryRepairInfoByStatementNo',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function queryAcceptanceInfoByStatementNo(data) {
  // 结算单列表-报账材料-验收表详情
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/queryAcceptanceInfoByStatementNo',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function queryRepairProofReportList(data) {
  // 结算单列表-报账材料-维修论证报告详情
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/queryRepairProofReportList',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function addStatementInfoToInvoice(data) {
  // 结算单列表-报账材料-添加结算单发票
  return request({
    url: 'ysa-afterSale-service/after_sale/asRepairOrdersMain/addStatementInfoToInvoice',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function getFundCardList(data) {
  // 获取经费卡列表
  return request({
    url: '/ysa-afterSale-service/after_sale/asFinance/queryAuthorizationAccountList',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function getEconomyCategoryList(data) {
  // 获取经济分类列表
  return request({
    url: "/ysa-afterSale-service/after_sale/asFinance/queryAuthorizationAccountList/".concat(data.projectCode),
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    }
    // data: JSON.stringify(data)
  });
}
export function handleReplaceAccount(data) {
  // 选择经费卡提交
  return request({
    url: '/ysa-afterSale-service/after_sale/asFinance/replaceAccount',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function generateStatementAcceptancePdf(data) {
  // 生成仪器设备维修验收表PDF文件
  return request({
    url: '/ysa-afterSale-service/after_sale/asStatement/generateStatementAcceptancePdf',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data),
    responseType: 'blob'
  });
}
export function generateStatementProofPdf(data) {
  // 生成维修可行性论证报告PDF文件
  return request({
    url: '/ysa-afterSale-service/after_sale/asStatement/generateStatementProofPdf',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data),
    responseType: 'blob'
  });
}
export function generateStatementRegisterPdf(data) {
  // 生成仪器设备维修登记表PDF文件
  return request({
    url: '/ysa-afterSale-service/after_sale/asStatement/generateStatementRegisterPdf',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data),
    responseType: 'blob'
  });
}
export function generatePdf(data) {
  // 生成仪器非固定资产申请表PDF文件
  return request({
    url: '/base/pdfHtml/generatePdf',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data),
    responseType: 'blob'
  });
}
export function generateRepairBooklet(data) {
  // 生成报账材料PDF文件
  return request({
    url: '/base/pdfHtml/generateRepairBooklet',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data),
    responseType: 'blob'
  });
}
export function uploadInvoiceVerifyFile(data) {
  // 上传发票验真文件
  return request({
    url: '/ysa-afterSale-service/after_sale/asStatement/uploadInvoiceVerifyFile',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: data
  });
}
export function deleteInvoiceVerifyFile(data) {
  // 删除发票验真文件
  return request({
    url: '/ysa-afterSale-service/after_sale/asStatement/deleteInvoiceVerifyFile',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
}
export function queryInvoiceVerifyFile(repairNo) {
  // 获取发票验真文件
  return request({
    url: "/ysa-afterSale-service/after_sale/asStatement/queryInvoiceVerifyFile/".concat(repairNo),
    method: 'post'
  });
}
export function batchDownloadAccountingMaterials(data) {
  // 结算单导出报账材料
  return request({
    url: '/ysa-afterSale-service/after_sale/asRepairOrdersMain/batchDownloadAccountingMaterials',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: data,
    responseType: 'blob'
  });
}